export const communitySizeSearchParamMap = {
  'up to 20 Beds': 'small',
  '20 - 51 Beds': 'medium',
  '51 +': 'large',
};
